/** Categories that require UKARA at checkout and seller verification before dispatch. */
export const UKARA_CATEGORY_ROOTS = ["Airsoft Guns", "BBS, Gas & Batteries"];

export function itemCategoryRequiresUkara(category) {
  const c = String(category || "").trim();
  if (!c) return false;
  return UKARA_CATEGORY_ROOTS.some(
    (root) => c === root || c.startsWith(`${root} > `)
  );
}

export function cartRequiresUkara(cart) {
  if (!Array.isArray(cart) || cart.length === 0) return false;
  return cart.some((item) => itemCategoryRequiresUkara(item?.category));
}

export function orderRequiresUkara(order) {
  return cartRequiresUkara(order?.cart);
}
